import React from "react";
import Section from "../../common/Section"
import { Card, CardBody, Col, Row } from "reactstrap";
import { Link } from "react-router-dom/cjs/react-router-dom";

const menu = [
    {
        title: "Terms of Service",
        to: "https://www.sikkasoft.com/terms-of-service",
    },
    {
        title: "Contact Us",
        to: "https://www.sikkasoft.com/contact-us",
    },
    {
        title: "Privacy Policy",
        to: "https://www.sikkasoft.com/privacy-policy",
    },
    {
        title: "HIPAA",
        to: "https://www.sikkasoft.com/terms-of-service#hipaa",
    }
]

const OAuthCardLayout = ({ url, name, children, lg = 5 }) => {
    return (
        <Section fluid className="py-0">
            <Row className="flex-center min-vh-100">
                <Col lg={lg} className="col-xxl-5 py-3">
                    <Card className="overflow-hidden">
                        <CardBody className="d-flex p-4 flex-center flex-column">
                            {url && <img src={url} className="w-20 img-oauth-logo" />}
                            {name && <h4 className="oauth-title oauth-text-bold">{name}</h4>}
                            {children}
                        </CardBody>
                    </Card>
                    <Row className="w-100 flex-center">
                        {
                            menu.map(({ title, to }, index) => {
                                return (<Link to={{ pathname: to }} key={index} target="_blank">
                                    <p className='d-flex fs--1 w-100 flex-center p-1'>
                                        {title}
                                    </p>
                                </Link>)
                            })
                        }
                    </Row>
                    <Row className="w-100 flex-center">
                        <p className="ml-1 mt-0 fs--1 fw-semi-bold text-black text-center opacity-100">
                            &copy; {new Date().getFullYear()} Copyright
                            <a className="cursor-pointer link-primary" onClick={() => {
                                window.location.href = "https://www.sikkasoft.com";
                            }}> Sikka Software Corporation</a>. All Rights Reserved.
                        </p>
                    </Row>
                </Col>
            </Row>
        </Section>
    )
}

export default OAuthCardLayout;